import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import { computed } from 'vue';
import { IconName } from 'JS/constants/icons';

type quickLinkType = { text: string, link: string, icon: IconName };


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterQuickLinks',
  setup(__props) {

const quickLinks = computed((): { mobile: quickLinkType[], desktop: quickLinkType[] } => ({
	mobile: [
		{ text: "Blain's Rewards", link: "/rewards/", icon: "rewards-badge" },
		{ text: "Gift Cards", link: "/gift-cards/", icon: "giftcard" },
		{ text: "Blain's Blog", link: "https://www.farmandfleet.com/blog/", icon: "blainblog" },
		{ text: "Shipping & Returns", link: "/shipping-returns/", icon: "truck" },
		{ text: "Automotive Service", link: "/automotive-service/", icon: "automotive-service" },
	],
	desktop: [
		{ text: "Blain's Rewards", link: "/rewards/", icon: "rewards-badge" },
		{ text: "Shipping & Returns", link: "/shipping-returns/", icon: "truck" },
		{ text: "Automotive Service", link: "/automotive-service/", icon: "automotive-service" },
		{ text: "Gift Cards", link: "/gift-cards/", icon: "giftcard" },
		{ text: "Careers", link: "https://careers.farmandfleet.com/", icon: "user" },
		{ text: "Blain's Blog", link: "https://www.farmandfleet.com/blog/", icon: "blainblog" },
	],
}));


return { __sfc: true,quickLinks, Icon }
}

})